import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterLinkActive } from '@angular/router';
import { BrowserXhr } from '@angular/http';
import { NgProgressModule, NgProgressBrowserXhr } from 'ngx-progressbar';

import { AppComponent } from './app.component';
import { MenuComponent } from './navbar/menu/menu.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { TopBarComponent } from './navbar/top-bar/top-bar.component';


import { routing } from './app-routing.module';
import { GestionStagiairesModule  } from './gestion-stagiaires/gestion-stagiaires.module';
import { GestionEntreprisesModule  } from './gestion-entreprises/gestion-entreprises.module';
import { GestionSujetsModule  } from './gestion-sujets/gestion-sujets.module';
import { AproposModule } from './apropos/apropos.module';


@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    NotFoundComponent,
    TopBarComponent
  ],
  imports: [
    BrowserModule,
    routing,
    AproposModule,
    GestionEntreprisesModule,
    GestionStagiairesModule,
    GestionSujetsModule,
    NgProgressModule
  ],
  providers: [
    RouterLinkActive,
    { provide: BrowserXhr, useClass : NgProgressBrowserXhr}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/Yassine/Desktop/gestion-stagiaires/src/app/app.module.ts